import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const services = [
  {
    id: 1,
    title: "Diseño Personalizado",
    description: "Creá productos únicos con tus propios diseños. Subí tu idea y nosotros la hacemos realidad con la mejor calidad.",
    icon: "fa-solid fa-wand-magic-sparkles",
    gradient: "linear-gradient(135deg, #000000 0%, #1f8e38 100%)"
  },
  {
    id: 2,
    title: "Envíos a Todo el País",
    description: "Llegamos a la puerta de tu casa. Comprá online y recibí tu pedido de forma segura y rápida en cualquier punto del país.",
    icon: "fa-solid fa-truck-fast",
    gradient: "linear-gradient(135deg, #1f8e38 0%, #25a000 100%)"
  },
  {
    id: 3,
    title: "Productos IA",
    description: "Explora nuestra colección de productos generados con Inteligencia Artificial o creá el tuyo propio con nuestro generador.",
    icon: "fa-brands fa-reddit-alien",
    gradient: "linear-gradient(135deg, #0a3d16 0%, #17702a 100%)"
  },
  {
    id: 4,
    title: "Proyectos a Medida",
    description: "Presupuestos para empresas, eventos o compras por mayor. Contactanos y armamos un plan adaptado a tus necesidades.",
    icon: "fa-solid fa-handshake",
    gradient: "linear-gradient(135deg, #000000 0%, #25a000 100%)"
  }
];

const ServicesSection = () => {
  return (
    <section className="services-section py-5 my-4 position-relative">
      <div className="container">
        <div className="text-center mb-5 section-header">
          <h2 className="fw-bold modern-title">Nuestros Servicios</h2>
          <p className="text-muted fs-5">Descubrí todo lo que podemos hacer por vos en nuestra plataforma.</p>
        </div>

        <div className="row g-4">
          {services.map((service) => (
            <div key={service.id} className="col-12 col-md-6 col-lg-3">
              <div className="service-card h-100 p-4 text-center rounded-4 modern-shadow">
                <div
                  className="service-icon-wrapper mx-auto mb-4 d-flex justify-content-center align-items-center"
                  style={{ background: service.gradient }}
                >
                  <i className={`${service.icon} fa-2x text-white`}></i>
                </div>
                <h4 className="fw-bold fs-5 mb-3">{service.title}</h4>
                <p className="text-muted lh-base">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
